import script from "./StatementListTable.vue?vue&type=script&setup=true&lang=js"
export * from "./StatementListTable.vue?vue&type=script&setup=true&lang=js"

import "./StatementListTable.vue?vue&type=style&index=0&id=ee5ab12a&lang=css"

const __exports__ = script;

export default __exports__